import { UserListSorting } from '@mnspro-cloud/services';
import {
  LessonResponse,
  TimeSlotResponse,
} from '@mnspro-cloud/services/lib/mnspro-cloud/api/v2';
import { filter } from 'lodash';
import moment from 'moment-timezone';
import React from 'react';
import {
  SignOffLevel,
  SignOffPendingUpdate,
} from '../../LessonSignOff/LessonSignOff.interface';
import { LessonCard } from './LessonCard';
import './LessonCardsGrouped.scss';

export interface LessonCardsGroupedProps {
  onCourseClick?: (lesson: LessonResponse) => void;
  grouped: GroupedLessons;
  showClasses: boolean;
  lessonTimePosition: LessonCardsGroupedTimePosition;
  showCourse: boolean;
  selfAzureId?: string;
  disabledSignOff?: boolean;
  onSignClick?: (lesson: LessonResponse, level: SignOffLevel) => void;
  onUnsignClick?: (lesson: LessonResponse, level: SignOffLevel) => void;
  pendingSignOffUpdates?: SignOffPendingUpdate[];
  usePeriodBackgroundStriping?: boolean;
  showSelectLessonIcon?: boolean;
  preferenceSorting: UserListSorting;
  isMultiLessonsSigning?: boolean;
}

export enum LessonCardsGroupedTimePosition {
  Top = 'topCardsGrouped',
  Left = 'leftCardsGrouped',
}

export type GroupedLessons = {
  [key: string]: {
    [key: string]: {
      timeSlot: TimeSlotResponse;
      lessons: LessonResponse[];
    };
  };
};

/**
 * Represents a lesson unit
 */
export const LessonCardsGrouped: React.FC<LessonCardsGroupedProps> = props => {
  const {
    grouped,
    lessonTimePosition,
    showClasses,
    onCourseClick,
    showCourse,
    selfAzureId,
    onSignClick,
    onUnsignClick,
    pendingSignOffUpdates,
    disabledSignOff,
    usePeriodBackgroundStriping,
    showSelectLessonIcon,
    preferenceSorting,
    isMultiLessonsSigning,
  } = props;

  const groupedLessons = Object.keys(grouped).map(date => (
    <div
      className={`flex flex-col groupedLessons position-${
        lessonTimePosition === LessonCardsGroupedTimePosition.Top ||
        lessonTimePosition === undefined
          ? 'top'
          : 'left'
      }`}
      key={date}
    >
      <h2 className="dayHeadline">
        {moment(date).format('ddd DD.MM.YYYY')}
      </h2>
      {Object.keys(grouped[date]).map((period, index) => (
        <div
          className={`teachingUnit ${
            usePeriodBackgroundStriping ? 'bg-' + (index % 2) : ''
          }`}
          key={index}
        >
          <div className="time">
            <span className="timePatternSlotName">
              {grouped[date][period].timeSlot.name}
            </span>
            <span>
              {`${grouped[date][period].timeSlot.start} -
            ${grouped[date][period].timeSlot.end}`}
            </span>
          </div>
          <div className="flex flex-col gap-2 flex-1 lessonsCardList">
            {grouped[date][period].lessons.map(lesson => {
              return (
                <LessonCard
                  lesson={lesson}
                  key={lesson.id}
                  showClasses={showClasses}
                  isMultiLessonChild={lesson.multiLessonId !== lesson.id}
                  disabledSignOff={disabledSignOff}
                  onCourseClick={onCourseClick}
                  showCourse={showCourse}
                  preferenceSorting={preferenceSorting}
                  selfAzureId={selfAzureId}
                  showSelectLessonIcon={showSelectLessonIcon}
                  onSignClick={level => {
                    if (onSignClick) {
                      onSignClick(lesson, level);
                    }
                  }}
                  onUnsignClick={level => {
                    if (onUnsignClick) {
                      onUnsignClick(lesson, level);
                    }
                  }}
                  pendingSignOffUpdates={
                    pendingSignOffUpdates !== undefined
                      ? filter(pendingSignOffUpdates, {
                          lessonId: lesson.id,
                        })
                      : undefined
                  }
                  isMultiLessonsSigning={isMultiLessonsSigning}
                />
              );
            })}
          </div>
        </div>
      ))}
    </div>
  ));

  return <>{groupedLessons.map(lesson => lesson)}</>;
};
